module.exports = __webpack_public_path__ + "img/Middle-Vertical-Rectangular-Attachment-15.963a0e38.png";